import type { LoadingButtonProps } from '@mui/lab';
import { LoadingButton } from '@mui/lab';
import { forwardRef } from 'react';

import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => {
  return {
    root: {
      borderRadius: '20px',
      cursor: 'pointer',
    },
  };
});

export type Or2LoadingButtonProps = LoadingButtonProps;

export const Or2LoadingButton = forwardRef<
  HTMLButtonElement,
  Or2LoadingButtonProps
>(
  (
    {
      variant = 'contained',
      disableElevation = true,
      children,
      className,

      ...other
    },
    ref,
  ) => {
    const { classes, cx } = useStyles();

    return (
      <LoadingButton
        ref={ref}
        className={cx(classes.root, className)}
        variant={variant}
        disableElevation={disableElevation}
        {...other}
      >
        {children}
      </LoadingButton>
    );
  },
);

Or2LoadingButton.displayName = 'Or2LoadingButton';
